const TRANSLATIONS = {
    en: {
        areYouSure: 'Are you sure you want to delete, "{0}"?',
        cancel: "I've changed my mind",
        delete: 'I understand',
        instructions: `Clicking the, "{0}" button below will permanently delete this node and all of its connections. You will not be able to undo this action.`,
        warning: 'Please read before continuing'
    }
}

export default TRANSLATIONS